module.exports = __webpack_public_path__ + "img/be.d8bddc15.svg";